import RequestRepository from '@/business/modules/request/request.repository';
import type { BookingSuggestionRequest, JoinWaitlistPayload, getTimeOfBusinessParams, inquiryPaymentParmas } from '@/business/modules/request/request.model';
import { ITEM_SIZE } from '@/presentation';
import { RequestMapper } from '@/business/core/mappers/request';

class RequestService {
	static #instance: RequestService;
	private readonly repository;

	private constructor() {
		this.repository = RequestRepository.getInstance();
	}

	public static getInstance(): RequestService {
		if (!RequestService.#instance) {
			RequestService.#instance = new RequestService();
		}

		return RequestService.#instance;
	}

	/* user */
	async getDoneReserveTimeUser(page: number): Promise<any> {
		const data = await this.repository.getAcceptedRequestsUser(true, page, ITEM_SIZE);
		const mapped = RequestMapper.formatRequestList(data.data.data);
		return { data: { ...data, data: mapped } };
	}

	async getFutureReserveTimeUser(page: number): Promise<any> {
		const data = await this.repository.getAcceptedRequestsUser(false, page, ITEM_SIZE);
		const mapped = RequestMapper.formatRequestList(data.data.data);
		return { data: { ...data, data: mapped } };
	}

	async getPendReserveTimeUser(page: number): Promise<any> {
		const data = await this.repository.getReserveTimeUser(0, page, ITEM_SIZE);
		const mapped = RequestMapper.formatRequestList(data.data.data);
		return { data: { ...data, data: mapped } };
	}

	async getCanceledReserveTimeUser(page: number): Promise<any> {
		const data = await this.repository.getReserveTimeUser(2, page, ITEM_SIZE);
		const mapped = RequestMapper.formatRequestList(data.data.data);
		return { data: { ...data, data: mapped } };
	}
	/* user */

	/* business */
	getPendReserveInBusinessBook(page: number) {
		return this.repository.getReserveTimeInBusinessBook(0, page, ITEM_SIZE);
	}

	getPendReservePreviewInBusinessBook() {
		return this.repository.getReserveTimeInBusinessBook(0, 1, 1);
	}

	getDoneReserveInBusinessBook(page: number): Promise<any> {
		return this.repository.getAcceptedRequestsInBusinessBook(true, page, ITEM_SIZE);
	}

	getFutureReserveInBusinessBook(page: number): Promise<any> {
		return this.repository.getAcceptedRequestsInBusinessBook(false, page, ITEM_SIZE);
	}
	/* business */

	acceptReserveTime(id: string) {
		return this.repository.setReserveStatus(id, 1);
	}

	rejectReserveTime(id: string) {
		return this.repository.setReserveStatus(id, 2);
	}

	markNoShow(id: string) {
		return this.repository.markNoShow(id);
	}

	cancelReserve(id: string) {
		return this.repository.cancelReserve(id);
	}

	getBookingSuggestions(data: BookingSuggestionRequest) {
		return this.repository.getBookingSuggestions({
			bookingMode: 'Together',
			mode: 'Fastest',
			togetherSearchDays: 7,
			includeSplitFallback: true,
			maxResults: 5,
			preferredArtistIds: [],
			...data,
		});
	}

	getWaitlistOffer(token: string) {
		return this.repository.getWaitlistOffer(token);
	}

	joinWaitlist(data: JoinWaitlistPayload) {
		return this.repository.joinWaitlist(data);
	}

	redirectToPayment(data: object) {
		return this.repository.redirectToPayment(data);
	}

	reserveWithoutPayment(data: object) {
		return this.repository.reserveWithoutPayment(data);
	}

	payWithWallet(data: object) {
		return this.repository.payWithWallet(data);
	}

	inquiryPayment(data: inquiryPaymentParmas) {
		return this.repository.inquiryPayment(data);
	}

	getRequestDetail(requestId: string, source: 'receive' | 'send' = 'receive') {
		return this.repository.getRequestDetail(requestId, source);
	}

	getTimeOfBusiness(data: getTimeOfBusinessParams) {
		return this.repository.getTimeOfBusiness(data);
	}
}

export default RequestService;
